import { CommunicationSVG } from 'components/iconsSVG/communication';
import { ProfileSVG } from 'components/iconsSVG/profile';
import { WishCategorySVG } from 'components/iconsSVG/wishCategory';
import { AccountBenefitsSVG } from 'components/iconsSVG/accountBenefits';
import { BoxSVG } from 'components/iconsSVG/box';
import { NNormalBoxSVG } from 'components/iconsSVG/nnormal-box';
import { NNormalProfileSVG } from 'components/iconsSVG/nnormal-profile';

import { IS_CAMPER } from 'utils/constants/system';

export const VERSIONS = {
  OLD: 1,
  NEW: 2,
};

const path = '/myaccount';

const baseCategories = IS_CAMPER ? [
  {
    title: [ 'mi.cuenta', 'mis.pedidos', 'My Orders' ],
    svg: <BoxSVG />,
    description: [ 'mi.cuenta', 'mis.pedidos.descripcion', 'Look for them and their status.' ],
    link: `${path}/myorders`,
  },
  {
    title: [ 'mi.cuenta', 'wishlist', 'Wishlist' ],
    svg: <WishCategorySVG />,
    description: [ 'mi.cuenta', 'wishlist.descripcion', 'See your favourite items.' ],
    link: `${path}/wishlist`,
  },
  {
    title: [ 'mi.cuenta', 'mi.perfil', 'My Profile' ],
    svg: <ProfileSVG />,
    description: [ 'mi.cuenta', 'mi.perfil.descripcion', 'Manage your personal data and preferences.' ],
    link: `${path}/myprofile`,
  },
  /* {
      title: [ 'mi.cuenta', 'mis.beneficios', 'My Benefits' ],
      svg: <BenefitSVG />,
      description: [ 'mi.cuenta', 'mis.beneficios.descripcion', 'Find them out.' ],
    },
    {
      title: [ 'mi.cuenta', 'direcciones', 'Address Book' ],
      svg: <BookSVG />,
      description: [ 'mi.cuenta', 'direcciones.descripcion', 'Manage your addresses.' ],
    }, */
  {
    title: [ 'mi.cuenta', 'comunicados', '**Communications' ],
    svg: <CommunicationSVG />,
    condition: () => false, // solo desde enlace
    description: [ 'mi.cuenta', 'comunicados.descripcion', 'Don\'t miss any information.' ],
    link: `${path}/mycommunications`,
  },
  {
    title: [ 'mi.cuenta', 'mis.beneficios', 'My Benefits' ],
    svg: <AccountBenefitsSVG />,
    description: [ 'mi.cuenta', 'mis.beneficios.descripcion', 'Find them out.' ],
    link: '/content/The-Walking-Society#benefits',
  },
] : [
  {
    title: [ 'mi.cuenta', 'mis.pedidos', 'My Orders' ],
    svg: <NNormalBoxSVG />,
    description: [ 'mi.cuenta', 'mis.pedidos.descripcion', 'Look for them and their status.' ],
    link: `${path}/myorders`,
  },
  // {
  //   title: [ 'mi.cuenta', 'wishlist', 'Wishlist' ],
  //   svg: <WishCategorySVG />,
  //   description: [ 'mi.cuenta', 'wishlist.descripcion', 'See your favourite items.' ],
  //   link: `${path}/wishlist`,
  // },
  {
    title: [ 'mi.cuenta', 'mi.perfil', 'My Profile' ],
    svg: <NNormalProfileSVG />,
    description: [ 'mi.cuenta', 'mi.perfil.descripcion', 'Manage your personal data and preferences.' ],
    link: `${path}/myprofile`,
  },
  /* {
      title: [ 'mi.cuenta', 'mis.beneficios', 'My Benefits' ],
      svg: <BenefitSVG />,
      description: [ 'mi.cuenta', 'mis.beneficios.descripcion', 'Find them out.' ],
    },
    {
      title: [ 'mi.cuenta', 'direcciones', 'Address Book' ],
      svg: <BookSVG />,
      description: [ 'mi.cuenta', 'direcciones.descripcion', 'Manage your addresses.' ],
    }, */
  {
    title: [ 'mi.cuenta', 'comunicados', '**Communications' ],
    svg: <CommunicationSVG />,
    condition: () => false, // solo desde enlace
    description: [ 'mi.cuenta', 'comunicados.descripcion', 'Don\'t miss any information.' ],
    link: `${path}/mycommunications`,
  },
];

export const categories = baseCategories;
